import moment from 'moment-timezone'

/**
 * Decides the status of the incident given the incident attributes
 */
function decideIncidentStatus(incidentAttr) {
  if (incidentAttr.outage) {
    return "outage"
  } else if (incidentAttr.degradation) {
    return "degradation"
  } else if (incidentAttr.maintenance) {
    return "maintenance"
  } else {
    return "normal"
  }
}

/**
 * Takes in a timezone and localizes and formats to inTimezone
 */
const localizeIncidentTimestamp = (timeStamp, inTimezone, minutes=true) => {
  const timeObj = moment.tz(timeStamp, "UTC")

  if (timeStamp == null) {
    return 'Ongoing'
  } else if (minutes) {
    return timeObj.tz(inTimezone).format('MMMM DD, YYYY hh:mm A')
  } else {
    return timeObj.tz(inTimezone).format('MMMM Do YYYY')
  }
}

const hasNonEmptyIncidentUpdates = incidentUpdates => {
  let substantiveUpdate = false
  if (incidentUpdates.length > 0) {
    incidentUpdates.map(update => {
      if (update.description) {
        substantiveUpdate = true
      }
    })
  }
  return substantiveUpdate
}

export { decideIncidentStatus, localizeIncidentTimestamp, hasNonEmptyIncidentUpdates }
